require('angular').module('wowApp.shop')
    .service('ShelfProductService', ['Restangular', 'DetailProductService', 'TrolleyService', require('./shelfproduct-service')])
    .directive('wowBundle', [require('./bundle-directive')])
    .directive('bwsProduct', ['$timeout', '$state', 'MoveFocus', 'SettingsService', require('./bws-product-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shelfproduct/index.js
 **/